import campStyles from './Campaigns.module.css';

export function CampaignHowItWorksCallout() {
  return (
    <div className={campStyles.brandDnaBanner} role="note">
      <strong>Hoe test &amp; KPI werken</strong>
      <ul className={campStyles.howItWorksList}>
        <li>
          <strong>Leads &amp; fase</strong> — per lead: sequence-stap (<code>step_index</code>), status
          (actief, reply, afgerond) en A/B-variant.
        </li>
        <li>
          <strong>Templates meten</strong> — elke verzonden mail koppelt aan een{' '}
          <code>email_template_id</code>. KPI per template staat onder tab <strong>Prestaties</strong>{' '}
          (reply, clicks).
        </li>
        <li>
          <strong>A/B-experiment</strong> — <em>sequence-path</em> (eigen sequence per variant) of{' '}
          <em>stap A/B</em> (2–8 templates/copy op één stap, flag <code>step_experiments_v1</code>);
          sticky per lead. Zie Overzicht → A/B / Stap A/B.
        </li>
        <li>
          <strong>Clicks</strong> — bij Brevo transactional via webhooks (<code>mail_clicked</code>);
          SMTP heeft (nog) geen link-proxy. Clicks kunnen bot/scanner-ruis bevatten; reply-rate blijft
          hoofd-KPI.
        </li>
        <li>
          <strong>Conversie</strong> — “gestopt: open deal” bij <code>exit_on_open_deal</code>; reply =
          menselijk inbound (geen bounce/OOO) → enrollment <code>stopped_reply</code>. Autoreplies worden
          gelogd als <code>mail_auto_reply</code> zonder sequence-stop.
        </li>
        <li>
          <strong>Website na klik</strong> — UTM op de CTA (zie FO e-mail UTM); GA4 is aanvullend, hub is
          system of record voor mail.
        </li>
      </ul>
    </div>
  );
}
